<template>
  <div class="sidebar-redesign sidebar-booker w-100">
    <div class="sidebar-booker__scroll">
      <!-- MENU PRINCIPAL DE BOOKER -->
      <template v-if="showFullBookerMenu">
        <router-link
          :to="'/booker-onboarding'"
          class="ol-nav-item-link"
          active-class="ol-active"
          @mousedown.native="navigate('/booker-onboarding')"
        >
          <div class="ol-nav-item">
            <span class="ol-nav-icon">
              <SidebarIcon name="onboarding" />
            </span>
            <span class="ol-nav-label">Onboarding</span>
          </div>
        </router-link>

        <router-link
          v-if="showLeadRoom"
          :to="'/admin-tasks'"
          class="ol-nav-item-link"
          active-class="ol-active"
          @mousedown.native="navigate('/my_team')"
        >
          <div class="ol-nav-item">
            <span class="ol-nav-icon">
              <SidebarIcon name="lead-room" />
            </span>
            <span class="ol-nav-label">Lead Room</span>
          </div>
        </router-link>

        <div class="ol-nav-group" :class="{ open: isOpenRessources }">
          <div
            class="ol-nav-item ol-nav-item--parent"
            @click="isOpenRessources = !isOpenRessources"
          >
            <span class="ol-nav-icon">
              <SidebarIcon name="resources" />
            </span>
            <span class="ol-nav-label">Ressources</span>
            <i class="fa fa-chevron-down ol-chev" aria-hidden="true"></i>
          </div>
          <div v-show="isOpenRessources" class="ol-submenu">
            <router-link
              :to="'/academy'"
              class="ol-sub-item-link"
              active-class="ol-active"
              @mousedown.native="navigate('/academy')"
            >
              <div class="ol-sub-item">
                <i class="icon-caret-right1" aria-hidden="true"></i>
                <span class="ol-sub-label">{{ $t("lang.label.academy") }}</span>
              </div>
            </router-link>
            <router-link
              :to="'/booker-clients'"
              class="ol-sub-item-link"
              active-class="ol-active"
              @mousedown.native="navigate('/clients')"
            >
              <div class="ol-sub-item">
                <i class="icon-caret-right1" aria-hidden="true"></i>
                <span class="ol-sub-label">Clients</span>
              </div>
            </router-link>
            <router-link
              v-if="showLeadRoom"
              :to="'/daily-reports'"
              class="ol-sub-item-link"
              active-class="ol-active"
              @mousedown.native="navigate('/my_team')"
            >
              <div class="ol-sub-item">
                <i class="icon-caret-right1" aria-hidden="true"></i>
                <span class="ol-sub-label">Synthèses</span>
              </div>
            </router-link>
          </div>
        </div>

        <div class="ol-nav-group" :class="{ open: isOpenReports }">
          <div
            class="ol-nav-item ol-nav-item--parent"
            @click="isOpenReports = !isOpenReports"
          >
            <span class="ol-nav-icon">
              <SidebarIcon name="reports" />
            </span>
            <span class="ol-nav-label">Rapports</span>
            <i class="fa fa-chevron-down ol-chev" aria-hidden="true"></i>
          </div>
          <div v-show="isOpenReports" class="ol-submenu">
            <router-link
              :to="'/dashboard'"
              class="ol-sub-item-link"
              active-class="ol-active"
              @mousedown.native="navigate('/dashboard')"
            >
              <div class="ol-sub-item">
                <i class="icon-caret-right1" aria-hidden="true"></i>
                <span class="ol-sub-label">Overview</span>
              </div>
            </router-link>
            <router-link
              :to="'/allbdr/2'"
              class="ol-sub-item-link"
              active-class="ol-active"
              @mousedown.native="navigate('/allbdr/2')"
            >
              <div class="ol-sub-item">
                <i class="icon-caret-right1" aria-hidden="true"></i>
                <span class="ol-sub-label">Tâches</span>
              </div>
            </router-link>
            <router-link
              :to="'/bookers-calls'"
              class="ol-sub-item-link"
              active-class="ol-active"
              @mousedown.native="navigate('/bookers-calls')"
            >
              <div class="ol-sub-item">
                <i class="icon-caret-right1" aria-hidden="true"></i>
                <span class="ol-sub-label">Appels</span>
              </div>
            </router-link>
            <router-link
              :to="'/allbdr/6'"
              class="ol-sub-item-link"
              active-class="ol-active"
              @mousedown.native="navigate('/allbdr/6')"
            >
              <div class="ol-sub-item">
                <i class="icon-caret-right1" aria-hidden="true"></i>
                <span class="ol-sub-label">Timing</span>
              </div>
            </router-link>
          </div>
        </div>

        <router-link
          :to="'/allbdr/5'"
          class="ol-nav-item-link"
          active-class="ol-active"
          @mousedown.native="navigate('/allbdr/5')"
        >
          <div class="ol-nav-item">
            <span class="ol-nav-icon">
              <SidebarIcon name="ranking" />
            </span>
            <span class="ol-nav-label">Classement</span>
          </div>
        </router-link>

        <router-link
          :to="'/meeting-attendance'"
          class="ol-nav-item-link"
          active-class="ol-active"
          @mousedown.native="navigate('/meeting-attendance')"
        >
          <div class="ol-nav-item">
            <span class="ol-nav-icon">
              <SidebarIcon name="attendance-monitor" />
            </span>
            <span class="ol-nav-label">Attendance</span>
          </div>
        </router-link>

        <router-link
          v-if="showManagerPools"
          :to="'/allbdr/16'"
          class="ol-nav-item-link"
          active-class="ol-active"
          @mousedown.native="navigate('/allbdr/16')"
        >
          <div class="ol-nav-item">
            <span class="ol-nav-icon"><i class="fa fa-line-chart"></i></span>
            <span class="ol-nav-label">Manager Pools</span>
          </div>
        </router-link>

        <div class="ol-nav-group" :class="{ open: isOpenRemuneration }">
          <div
            class="ol-nav-item ol-nav-item--parent"
            @click="isOpenRemuneration = !isOpenRemuneration"
          >
            <span class="ol-nav-icon">
              <SidebarIcon name="revenue" />
            </span>
            <span class="ol-nav-label">Rémunération</span>
            <i class="fa fa-chevron-down ol-chev" aria-hidden="true"></i>
          </div>
          <div v-show="isOpenRemuneration" class="ol-submenu">
            <router-link
              :to="'/allbdr/10'"
              class="ol-sub-item-link"
              active-class="ol-active"
              @mousedown.native="navigate('/allbdr/10')"
            >
              <div class="ol-sub-item">
                <i class="icon-caret-right1" aria-hidden="true"></i>
                <span class="ol-sub-label">Paiements</span>
              </div>
            </router-link>
            <router-link
              :to="'/allbdr/12'"
              class="ol-sub-item-link"
              active-class="ol-active"
              @mousedown.native="navigate('/allbdr/12')"
            >
              <div class="ol-sub-item">
                <i class="icon-caret-right1" aria-hidden="true"></i>
                <span class="ol-sub-label">Consistency</span>
              </div>
            </router-link>
            <router-link
              :to="'/allbdr/11'"
              class="ol-sub-item-link"
              active-class="ol-active"
              @mousedown.native="navigate('/allbdr/11')"
            >
              <div class="ol-sub-item">
                <i class="icon-caret-right1" aria-hidden="true"></i>
                <span class="ol-sub-label">Referral</span>
              </div>
            </router-link>
            <router-link
              :to="'/booker-commission'"
              class="ol-sub-item-link"
              active-class="ol-active"
              @mousedown.native="navigate('/booker-commission')"
            >
              <div class="ol-sub-item">
                <i class="icon-caret-right1" aria-hidden="true"></i>
                <span class="ol-sub-label">Commission</span>
              </div>
            </router-link>
          </div>
        </div>
      </template>

      <!-- Screening VISTA -->
      <template v-else-if="showScreeningMenu">
        <router-link
          :to="'/academy'"
          class="ol-nav-item-link"
          active-class="ol-active"
          @mousedown.native="navigate('/academy')"
        >
          <div class="ol-nav-item">
            <span class="ol-nav-icon">
              <SidebarIcon name="resources" />
            </span>
            <span class="ol-nav-label">{{ $t("lang.label.academy") }}</span>
          </div>
        </router-link>

        <router-link
          :to="'/merci-hubert'"
          class="ol-nav-item-link"
          active-class="ol-active"
          @mousedown.native="navigate('/allbdr/2')"
        >
          <div class="ol-nav-item">
            <span class="ol-nav-icon"><i class="icon-handshake-o"></i></span>
            <span class="ol-nav-label">Entretien</span>
          </div>
        </router-link>
      </template>

      <!-- Onboarding VISTA -->
      <template v-else-if="showOnboardingMenu">
        <router-link
          :to="'/booker-onboarding'"
          class="ol-nav-item-link"
          active-class="ol-active"
          @mousedown.native="navigate('/booker-onboarding')"
        >
          <div class="ol-nav-item">
            <span class="ol-nav-icon">
              <SidebarIcon name="onboarding" />
            </span>
            <span class="ol-nav-label">Onboarding</span>
          </div>
        </router-link>

        <router-link
          :to="'/merci-hubert'"
          class="ol-nav-item-link"
          active-class="ol-active"
          @mousedown.native="navigate('/merci-hubert')"
        >
          <div class="ol-nav-item">
            <span class="ol-nav-icon"><i class="icon icon-phone"></i></span>
            <span class="ol-nav-label">Virtual Agent</span>
          </div>
        </router-link>

        <router-link
          :to="'/academy'"
          class="ol-nav-item-link"
          active-class="ol-active"
          @mousedown.native="navigate('/academy')"
        >
          <div class="ol-nav-item">
            <span class="ol-nav-icon">
              <SidebarIcon name="resources" />
            </span>
            <span class="ol-nav-label">{{ $t("lang.label.academy") }}</span>
          </div>
        </router-link>
      </template>

      <div
        v-if="bookerShowSettings || bookerShowHelp"
        class="ol-sidebar-booker-meta"
      >
        <router-link
          v-if="bookerShowSettings"
          :to="'/settings-account'"
          class="ol-nav-item-link"
          active-class="ol-active"
          @mousedown.native="navigate('/settings-account')"
        >
          <div class="ol-nav-item">
            <span class="ol-nav-icon">
              <SidebarIcon name="settings" />
            </span>
            <span class="ol-nav-label">{{ $t("lang.button.settings") }}</span>
          </div>
        </router-link>

        <a
          v-if="bookerShowHelp"
          target="_blank"
          class="ol-nav-item-link"
          href="https://help.oliverlist.com/knowledge"
        >
          <div class="ol-nav-item">
            <span class="ol-nav-icon">
              <SidebarIcon name="help" />
            </span>
            <span class="ol-nav-label">{{ $t("lang.button.help") }}</span>
          </div>
        </a>
      </div>
    </div>

    <div class="sidebar-booker__spacer" aria-hidden="true"></div>

    <div class="ol-sidebar-footer ol-sidebar-footer--logout">
      <router-link
        :to="'/login'"
        class="ol-nav-item-link"
        @mousedown.native="navigate('/login')"
      >
        <div class="ol-nav-item">
          <span class="ol-nav-icon">
            <SidebarIcon name="logout" :size="16" />
          </span>
          <span class="ol-nav-label">{{ $t("lang.button.logout") }}</span>
        </div>
      </router-link>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import SidebarIcon from "@/assets/icons/sidebar/SidebarIcon.vue";

const BOOKER_MAIN_MENU_BLOCKED = [
  "Screening",
  "Onboarding",
  "Rejected (interview)",
  "Outdated",
  "Rejected (trial)",
  "Stopped",
];

const BOOKER_LEAD_ROOM_HIDDEN = [
  "Training",
  "Suspended",
  "Stopped",
  "Rejected (interview)",
  "Rejected (trial)",
];

export default {
  name: "SidebarBooker",

  components: { SidebarIcon },

  data() {
    return {
      isOpenRessources: false,
      isOpenReports: false,
      isOpenRemuneration: false,
    };
  },

  computed: {
    ...mapState({
      user: (state) => state.authentication.user,
    }),

    parentMenuReady() {
      const parent = this.$parent;
      return !!(parent && parent.menu);
    },

    showFullBookerMenu() {
      if (!this.parentMenuReady) {
        return false;
      }
      return !this.isBdrUser(BOOKER_MAIN_MENU_BLOCKED);
    },

    showScreeningMenu() {
      return this.isBdrUser(["Screening", "Outdated"]);
    },

    showOnboardingMenu() {
      return (
        this.user &&
        this.user.booker &&
        this.user.booker.status === "Onboarding"
      );
    },

    showLeadRoom() {
      if (!this.user || !this.user.booker) {
        return false;
      }
      return !BOOKER_LEAD_ROOM_HIDDEN.includes(this.user.booker.status);
    },

    showManagerPools() {
      return (
        this.user &&
        this.user.booker &&
        this.user.booker.status === "Booker Manager"
      );
    },

    bookerShowSettings() {
      return !(
        this.isUserOperational ||
        this.isUserContable ||
        this.isUserAttendance
      );
    },

    bookerShowHelp() {
      return !(
        (this.user.team_role_id !== undefined && this.user.team_role_id == 3) ||
        this.user.role_id == 4 ||
        this.isUserOperational ||
        this.isUserContable ||
        this.isUserBookerRecuiter ||
        this.isUserAttendance
      );
    },

    isUserOperational() {
      return this.user.role_id == 1 && this.user.user_constraint_id == 1;
    },
    isUserContable() {
      return this.user.role_id == 1 && this.user.user_constraint_id == 4;
    },
    isUserAttendance() {
      return this.user.role_id == 1 && this.user.user_constraint_id == 7;
    },
    isUserBookerRecuiter() {
      return this.user.role_id == 1 && this.user.user_constraint_id == 5;
    },
  },

  methods: {
    ...mapMutations("sidebar", {
      NavigationClicked: "navigationClicked",
    }),

    isBdrUser(status) {
      if (!this.user || Number(this.user.role_id) !== 2) {
        return false;
      }
      if (Number(this.user.team_role_id) !== 2) {
        return false;
      }
      if (!this.user.booker) {
        return false;
      }
      if (status) {
        return status.includes(this.user.booker.status);
      }
      return true;
    },

    navigate(routeTo) {
      const parent = this.$parent;
      const isMobile = parent && parent.isMobile;

      if (isMobile && this.$route.fullPath !== routeTo) {
        const toggle = parent.$refs && parent.$refs.toggleMenu2;
        if (toggle) {
          toggle.click();
        }
        this.$router.push({ path: routeTo });
      }

      if (this.$route.fullPath === routeTo) {
        return;
      }

      if (this.$route.path.includes(routeTo)) {
        this.NavigationClicked();
        this.$router.push({ path: routeTo });
      }
    },
  },
};
</script>

<style scoped>
.sidebar-booker {
  --ol-sidebar-bg: #fbfbfa;
  --ol-border: #ededec;
  --ol-text: #1a1a18;
  --ol-text-secondary: #6b6b67;
  --ol-text-tertiary: #9a9a96;
  --ol-hover: #f0f0ee;
  --ol-active: #ebebe9;
  --ol-accent: #5054EB;
  --ol-accent-soft: #f3f1fd;
  --ol-radius: 8px;

  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  min-height: 0;
  width: 100%;
  padding: 0 0 8px;
}

.sidebar-booker__scroll {
  flex: 1 1 auto;
  min-height: 0;
  overflow-x: hidden;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.ol-sidebar-booker-meta {
  flex-shrink: 0;
  padding-top: 2px;
}

.sidebar-booker__spacer {
  flex: 1 1 auto;
  min-height: 8px;
}

.ol-nav-item-link {
  display: block;
  text-decoration: none !important;
  color: inherit;
  margin: 1px 0;
}

.ol-nav-item {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 11px;
  padding: 8px 9px;
  border-radius: var(--ol-radius);
  font-size: 13.5px;
  color: var(--ol-text);
  cursor: pointer;
  user-select: none;
  text-align: left;
}

.ol-nav-item--parent {
  width: 100%;
}

.ol-nav-item-link:hover .ol-nav-item,
.ol-nav-item--parent:hover {
  background: var(--ol-hover);
}

.ol-nav-item-link.ol-active .ol-nav-item,
.ol-sub-item-link.ol-active .ol-sub-item {
  background: var(--ol-active);
  font-weight: 600;
}

.ol-sub-item-link.ol-active .ol-sub-item {
  background: var(--ol-accent-soft);
  color: var(--ol-accent);
}

.ol-nav-icon {
  width: 18px;
  height: 18px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: var(--ol-text-secondary);
  flex-shrink: 0;
}

.ol-nav-item-link.ol-active .ol-nav-icon {
  color: var(--ol-accent);
}

.ol-nav-label {
  flex: 1 1 auto;
  min-width: 0;
  line-height: 1.3;
  text-align: left;
}

.ol-nav-group > .ol-nav-item--parent .ol-chev {
  margin-left: auto;
  color: var(--ol-text-tertiary);
  font-size: 10px;
  transition: transform 0.18s ease;
}

.ol-nav-group:not(.open) > .ol-nav-item--parent .ol-chev {
  transform: rotate(-90deg);
}

.ol-submenu {
  margin: 2px 0 4px;
  padding-left: 4px;
}

.ol-sub-item-link {
  display: block;
  text-decoration: none !important;
  color: inherit;
}

.ol-sub-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 9px 6px 30px;
  border-radius: 6px;
  font-size: 12.8px;
  color: var(--ol-text-secondary);
  position: relative;
}

.ol-sub-item-link:hover .ol-sub-item {
  background: var(--ol-hover);
  color: var(--ol-text);
}

.ol-sidebar-footer {
  flex: 0 0 auto;
}

.ol-sidebar-footer--logout {
  border-top: 1px solid var(--ol-border);
  padding-top: 10px;
  padding-bottom: 4px;
}

.ol-sidebar-footer--logout .ol-nav-item,
.ol-sidebar-footer--logout .ol-nav-icon {
  color: var(--ol-text-secondary);
}

.ol-sidebar-footer--logout .ol-nav-item-link:hover .ol-nav-item {
  background: var(--ol-hover);
  color: var(--ol-text);
}
</style>
